import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import classnames from "classnames";
import { toast } from "react-toastify";
import { TypeOptions } from "react-toastify/dist/types";
import { FormattedMessage } from "react-intl";

import { Icon } from "../../icon/Icon";
import {
  NOTIFICATION_TYPES,
  NotificationMessageOptions,
} from "./notification.types";
import { Notificator as NotificatorActions } from "./notification.actions";

const NOTIFICATION_ICONS = {
  [NOTIFICATION_TYPES.SUCCESS]: "fa-solid fa-check-circle",
  [NOTIFICATION_TYPES.INFO]: "fa-solid fa-info-square",
  [NOTIFICATION_TYPES.ERROR]: "fa-solid fa-ban",
  [NOTIFICATION_TYPES.WARNING]: "fa-solid fa-exclamation-triangle",
};

interface NotificationProps extends NotificationMessageOptions {
  id: string;
  type: TypeOptions;
  CloseButton?: any;
}

export const NotificationToast = ({
  id,
  type,
  title,
  values,
}: NotificationProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(NotificatorActions.remove(id));
    };
  }, [id, dispatch]);

  const icon = NOTIFICATION_ICONS[type];

  return (
    <div className="notification">
      <Icon icon={classnames(icon, "notification__icon")} />
      <div className="notification__content">
        {title && (
          <div className="notification__title">
            <FormattedMessage id={title} />
          </div>
        )}
        <div className="notification__text">
          <FormattedMessage id={id} values={values} />
        </div>
      </div>
    </div>
  );
};

interface NotificationServiceOptions extends NotificationProps {
  type: TypeOptions;
}

export const NotificatorService = {
  show({ id, type, title, values }: NotificationServiceOptions) {
    toast(
      <NotificationToast id={id} type={type} title={title} values={values} />,
      {
        type,
        toastId: id,
      }
    );
  },
  showPermanent({ id, type, CloseButton }: NotificationServiceOptions) {
    toast(<NotificationToast id={id} type={type} />, {
      type,
      toastId: id,
      autoClose: false,
      closeButton: CloseButton,
    });
  },
  update: toast.update,
  isActive: toast.isActive,
  dismiss: toast.dismiss,
};
